exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "header{position:fixed;width:100vw;text-align:center;z-index:10;padding:3rem 1rem 0;z-index:12000}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./public/_src/_vue/Shell.vue
 ** module id = 9
 ** module chunks = 0
 **/